import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { DashedTitle, InfoMessage } from '@fasstech/middle-design-system';
import { FormLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import {
  emailRules,
  isMobilePhoneNumberValid,
  nameIsValid
} from '@@viewHelpers/validations';
import { ControlledInput, ControlledPhoneInput } from '@@viewCommonComponents/controlled';

const SouscriptionCompanyDecisionMakerContact = ({
  getMiddleText,
  getMiddleBoolean,
  isDisplayed,
  phoneIndicatives
}) => {
  const form = useFormContext();

  if (!isDisplayed) return null;

  return (
    <FormLayout>
      <DashedTitle>{getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_TITLE')}</DashedTitle>
      <InfoMessage iconName={'lightbulb'}>
        {getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_MESSAGE_INFO')}
      </InfoMessage>

      <ControlledInput
        name="decisionMakerContact.lastName"
        label={getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_NOM_LABEL')}
        form={form}
        rules={nameIsValid(true)}
        data-testid="ENTREPRISE_CONTACT_DECIDEUR_NOM"
      />

      <ControlledInput
        name="decisionMakerContact.firstName"
        label={getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_PRENOM_LABEL')}
        form={form}
        rules={nameIsValid(true)}
        data-testid="ENTREPRISE_CONTACT_DECIDEUR_PRENOM"
      />

      <ControlledPhoneInput
        name={'decisionMakerContact.phones.0'}
        label={getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_TELEPHONE_LABEL')}
        form={form}
        rules={isMobilePhoneNumberValid(
          getMiddleBoolean('ENTREPRISE_CONTACT_DECIDEUR_TELEPHONE_OBLIGATOIRE')
        )}
        isInternational
        options={phoneIndicatives || []}
        data-testid="ENTREPRISE_CONTACT_DECIDEUR_TELEPHONE"
      />
      <InfoMessage iconName={'lightbulb'}>
        {getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_TELEPHONE_MESSAGE_INFO')}
      </InfoMessage>

      <ControlledInput
        name="decisionMakerContact.emails.0.value"
        label={getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_EMAIL_LABEL')}
        form={form}
        rules={emailRules(getMiddleBoolean('ENTREPRISE_CONTACT_DECIDEUR_EMAIL_OBLIGATOIRE'))}
        data-testid="ENTREPRISE_CONTACT_DECIDEUR_EMAIL"
        displayErrorMessage={true}
      />
      <InfoMessage iconName={'lightbulb'}>
        {getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_EMAIL_MESSAGE_INFO')}
      </InfoMessage>
    </FormLayout>
  );
};

SouscriptionCompanyDecisionMakerContact.propTypes = {
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  isDisplayed: PropTypes.bool,
  phoneIndicatives: PropTypes.array
};

export default SouscriptionCompanyDecisionMakerContact;
